import { render, staticRenderFns } from "./ButtonJourney.vue?vue&type=template&id=22ed8d08&scoped=true&"
import script from "./ButtonJourney.vue?vue&type=script&lang=js&"
export * from "./ButtonJourney.vue?vue&type=script&lang=js&"
import style0 from "./ButtonJourney.vue?vue&type=style&index=0&id=22ed8d08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ed8d08",
  null
  
)

export default component.exports